module.exports = __webpack_public_path__ + "static/media/search.2b5feb95.svg";